import {
  getAvailable,
  getAvailableFormItems,
  checkFlowAble,
  processCheck,
  getDeptList,
  getProcess
} from '@/api/seal/seal'
import { useDealFormItems } from '@/hooks/useDealFormItems'
import { Toast, Dialog } from 'vant'
import { useRouter } from 'vue-router'
import {ref, reactive} from 'vue'

export const useBeforeApply = () => {
  const { dealControlData } = useDealFormItems()
  const router = useRouter()
  const popupShow = ref(false)
  const beforeApplyState = reactive({
    ocrPopupShow: false, // ocr预警弹窗
    deptList: [] // 部门列表
  })


  const showSheet = async () => {
    // 判断是否有可用业务流程
    const checkRes = await processCheck()
    if (!checkRes.data) return Toast('暂无可用的用印流程')

    // 获取所有所属部门列表
    const deptRes = await getDeptList()
    console.log('deptRes', deptRes)
    beforeApplyState.deptList = deptRes.data
    popupShow.value = true
  }

  const changeShow = (flag) => {
    console.log('触发了', flag)
    popupShow.value = flag
  }

  // 关闭选择框
  const closePop = () => {
    popupShow.value = false
  }

  const toApply = async (processId, deptId) => {
    Toast.loading({
      duration: 0,
      message: '加载中...',
      forbidClick: true
    })

    const isUse = await checkFlowAble(processId)
    if (
      isUse.code === 8003 ||
      isUse.code === 8004 ||
      isUse.code === 8010 ||
      isUse.code === 8022
    ) {
      const obj = {
        8003: '业务流程停用',
        8004: '业务流程不可用',
        8010: '业务流程不可用',
        8022: '所在部门变更'
      }
      return Dialog.confirm({
        title: obj[isUse.code],
        message: isUse.message,
        confirmButtonText: '重新选择',
        showCancelButton: true
      })
        .then(() => {
          // on confirm
          showSheet()
        })
        .catch(() => {
          // on cancel
        })
    }
    if (isUse.code === 8006) {
      Dialog.alert({
        title: '业务流程修改',
        message: isUse.message,
        confirmButtonText: '确定'
      }).then(() => {
        toApply(processId, deptId)
      })
      return
    } else if (isUse.code == 1082) {
      beforeApplyState.ocrPopupShow = true
      popupShow.value = false
      Toast.clear()
      return
    }

    const res = await getAvailableFormItems({ processId })
    // 动态表单

    if (res.code === 0) {
      closePop()
      dealControlData(res.data)
      setTimeout(() => {
        Toast.clear()
        router.push({ path: '/apply3', query: { deptId } })
      }, 1000)
    }
  }

  // ocr弹窗操作
    const ocrSubmit = () => {
      beforeApplyState.ocrPopupShow = false
    }

  return {
    popupShow,
    beforeApplyState, 
    changeShow,
    closePop,
    toApply,
    showSheet,
    ocrSubmit
  }
}